<template>
  <div class="share-link">
    <div class="share-link__form">
      <input class="share-link__form__input" ref="input" :value="linkUrl" readonly @click="selectInput" />
      <button class="share-link__form__button share-link__button" title="Click to Copy" @click.capture="handleCopy">{{buttonCopy}}</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { LANDING_URL } from '../core/config';

export default {
  name: 'share-link',
  props: {
    linkUrl: { default: LANDING_URL },
    buttonCopy: { type: String, default: 'Click to copy' },
  },
  data() {
    return {
      formOpen: false,
      formClosed: true,
    };
  },
  computed: {
    ...mapGetters('windowMedia', [
      'isIos'
    ]),
  },
  mounted() {
    this.selectInput();
  },
  methods: {
    handleCopy() {
      this.copyToClipboard();
      this.$emit('copy');
    },
    selectInput() {
      if (!this.$refs.input) {
        return;
      }
      if (this.isIos) {
        this.selectInputIOS();
        return;
      }
      this.$refs.input.select();
    },
    /**
     * Selcting on iOS is more complicated
     *
     * https://trello.com/c/U4JrbmsU/2822-copy-to-clipboard-button-is-not-working-as-expected
     */
    selectInputIOS() {
      if (!this.$refs.input) {
        return;
      }
      const { input } = this.$refs;
      input.contenteditable = true;
      input.readonly = false;
      const range = document.createRange();
      range.selectNodeContents(input);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      input.setSelectionRange(0, 999999);
      input.contenteditable = false;
      input.readonly = true;
    },
    copyToClipboard() {
      if (!this.$refs.input) {
        return;
      }
      if (this.isIos) {
        this.selectInputIOS();
      } else {
        this.selectInput();
      }
      document.execCommand('copy');
    },
  },
};
</script>
<style lang="scss">
  .share-link {
    position: relative;
    width: $size-width-share-link-form-large;
    height: $size-height-share-link-form-large;

    @include global-media('small') {
      width: $size-width-share-link-form-small;
      height: $size-height-share-link-form-small;
    }
    &__form {
      display: flex;
      justify-content: flex-end;
      border: $size-border-share-link-form-large solid $color-border-share-link-form-base;
      border-radius: $size-border-radius-share-link-form-large;
      overflow: hidden;
      height: 100%;
      margin-right: $size-margin-share-link-form-right;
      @include global-media('small') {
        border-size: $size-border-share-link-form-small;
        border-radius: $size-border-radius-share-link-form-small;
      }
      &__input {
        background: transparent;
        flex: 1 1 auto;
        -webkit-appearance: none;
        -webkit-highlight: none;
        border: 0;
        outline: none;

        color: $color-background-share-link-form-input-base;
        color: $color-text-share-link-form-input-base;

        padding: {
          right: $size-padding-share-link-form-input-large;
          left: $size-padding-share-link-form-input-large;
        }
        font-size: $size-text-share-link-form-input-large;

        @include global-media('small') {
          padding: {
            right: $size-padding-share-link-form-input-small;
            left: $size-padding-share-link-form-input-small;
          }
          font-size: $size-text-share-link-form-input-small;
        }

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: inherit;
        &::-ms-clear { display: none; }
      }
      &__button {
        @include button-base;
        display: flex;
        flex: 0 0 auto;
        justify-content: center;
        align-items: center;
        border-radius: 0;
        background: $color-background-share-link-form-button-base;
        color: $color-text-share-link-form-button-base;
        transition: background-color $time-global-transition-base linear;
        height: auto;
        width: $size-width-share-link-form-button-large;
        font-size: $size-text-share-link-form-button-large;
        //  border-top-right-radius: $size-border-radius-share-link-form-large;
        //   border-bottom-right-radius: $size-border-radius-share-link-form-large;
          line-height: 0;
        &:hover {
          background: $color-background-share-link-form-button-hover;
        }
        &:disabled {
          background: $color-background-share-link-form-button-disabled;
        }

        @include global-media('small') {
          font-size: $size-text-share-link-form-button-small;
          width: $size-width-share-link-form-button-small;
          height: $size-height-share-link-form-small;
          // border-top-right-radius: $size-border-radius-share-link-form-small;
          // border-bottom-right-radius: $size-border-radius-share-link-form-small;
        }


      }
    }
  }
</style>
